<template>
  <div>
    <q-tab-panels v-model="tab"
                  animated
                  transition-prev="scale"
                  transition-next="scale"
                  keep-alive
                  class="fit">
      <q-tab-panel style="padding: 2px"
                   name="grid">
        <!-- MAIN BAR-->
        <q-bar class="bg-secondary text-primary rounded-borders">
          <!-- BAR MENU DE ACCIONES DE REGISTROS -->
          <q-btn v-if="!selRow && !props.opts.hasOwnProperty('locked')"
                 dense
                 flat
                 color="primary"
                 icon="add"
                 @click="prepareData('insert')"></q-btn>
          <template v-if="selRow && !props.opts.hasOwnProperty('locked')">
            <q-btn dense
                   flat
                   color="primary"
                   icon="edit"
                   @click="prepareData('update')"></q-btn>
            <q-btn dense
                   flat
                   color="primary"
                   icon="content_copy"
                   @click="prepareData('duplicate')"></q-btn>
            <q-btn dense
                   flat
                   color="negative"
                   icon="delete_forever"
                   @click="prepareData('delete')"></q-btn>
            <q-btn v-if="Platform.is.mobile"
                   dense
                   flat
                   color="primary"
                   icon="find_in_page"
                   @click="prepareData('view')"></q-btn>
          </template>
          <q-space></q-space>
          <q-space></q-space>
          <!-- BAR BUSQUEDA RAPIDA -->
          <q-input borderless
                   v-model="quickFilter"
                   dense
                   color="primary"
                   placeholder="Buscar..."
                   style="width: 250px">
            <template v-slot:prepend><q-icon :color="quickFilter !== '' ? 'negative' : 'grey'"
                      dense
                      name="search"></q-icon></template>
          </q-input>
          <!-- BAR SELECTOR DE FECHAS -->
          <q-btn dense
                 flat
                 color="primary"
                 icon="date_range"
                 v-if="showDateSelector">
            <q-popup-proxy>
              <q-date v-model="modelDate"
                      minimal
                      range
                      @range-end="OkDate = true"
                      @range-start="OkDate = false"
                      mask="YYYY-MM-DD">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup
                         label="Cerrar"
                         color="secondary"
                         flat></q-btn>
                  <q-btn v-if="OkDate"
                         v-close-popup
                         label="Borrar"
                         color="negative"
                         flat
                         @click="checkDate(false)"></q-btn>
                  <q-btn v-if="OkDate"
                         v-close-popup
                         label="OK"
                         @click="checkDate(true)"
                         color="primary"
                         flat></q-btn>
                </div>
              </q-date>
            </q-popup-proxy>
            <q-tooltip> Seleccionar Fecha </q-tooltip>
          </q-btn>
          <!-- BAR BOTON DESCARGA EXCEL -->
          <q-btn color="primary"
                 flat
                 dense
                 icon="download"
                 @click="exportExcel">
            <q-tooltip> Descargar EXCEL </q-tooltip></q-btn>
          <!--  BAR BOTON CHARTS -->
          <q-btn color="primary"
                 flat
                 dense
                 icon="bar_chart"
                 @click="viewChart"
                 v-if="showDateSelector">
            <q-tooltip> Mostrar Gráficos </q-tooltip>
          </q-btn>
          <!-- BAR BOTON ACTUALIZAR DATOS -->
          <q-btn dense
                 flat
                 icon="refresh"
                 @click="update(props.opts.post)">
            <q-tooltip> Actualizar </q-tooltip>
          </q-btn>
        </q-bar>
        <!-- SECOND BAR -->
        <q-bar class="bg-white text-primary rounded-borders">
          <div class="col q-gutter-xs">
            <slot name="buttons"></slot>
          </div>
          <q-space></q-space>
          <div>.</div>
        </q-bar>
        <!-- TABLE GRID -->
        <!-- editType="fullRow"-->
        <ag-grid-vue :animateRows="true"
                     :autoSizePadding="2"
                     :autoSizeStrategy="autoSizeStrategy"
                     :cellSelection="true"
                     :columnDefs="columnDefs"
                     :columnTypes="columnTypes"
                     :defaultColDef="defaultColDef"
                     :detailCellRendererParams="detailCellRendererParams"
                     :detailRowHeight="300"
                     editType="fullRow"
                     :enterNavigatesVertically="true"
                     :enterNavigatesVerticallyAfterEdit="true"
                     :localeText="lang"
                     :masterDetail="!!(props.opts.details && props.opts.details.length > 0)"
                     :rowData="rowData"
                     :rowSelection="rowSelection"
                     :rowrowDeselection="true"
                     :rowClassRules="rowClassRules"
                     :selectionColumnDef="selectionColumnDef"
                     :sideBar="sideBar"
                     :statusBar="statusBar"
                     :suppressAnimationFrame="false"
                     :suppressColumnVirtualisation="true"
                     :suppressDragLeaveHidesColumns="true"
                     :suppressGroupChangesColumnVisibility="false"
                     :suppressMenuHide="true"
                     :theme="myTheme"
                     :undoRedoCellEditing="true"
                     @filter-changed="onFilterChanged"
                     @model-updated="onModelUpdated"
                     @grid-ready="onGridReady"
                     @grid-size-changed="onGridSizeChanged"
                     @first-data-rendered="onFirstDataRendered"
                     @row-value-changed="onRowValueChanged"
                     @selection-changed="onSelectionChanged"
                     :getContextMenuItems="getContextMenuItemsMaster"
                     multiSortKey="ctrl"
                     rowGroupPanelShow="always"
                     style="height: 70vh">
        </ag-grid-vue>
      </q-tab-panel>
      <!-- PANEL DE EDICION DE DATOS -->
      <q-tab-panel style="padding: 2px"
                   name="edit">
        <!-- BOTONES DE GUARDAR Y VOLVER -->
        <q-bar class="bg-secondary text-primary">
          <q-btn color="negative"
                 label="cancelar"
                 icon="cancel"
                 @click="tab = 'grid'"></q-btn>
          <q-space></q-space>
          <!-- <q-btn color="primary" label="Subir Archivo" icon="upload" @click="tab = 'grid'"></q-btn> -->
          <q-space></q-space>
          <q-btn color="positive"
                 label="guardar"
                 icon="save"
                 @click="onSave()">
          </q-btn>
        </q-bar>
        <q-scroll-area style="height: 70vh"
                       class="shadow-2 rounded-borders">
          <!-- FORMULARIO EDITAR DATOS -->
          <q-form @submit="onSave"
                  ref="myForm">
            <div class="row q-col-gutter-xs q-pa-xs">
              <template v-for="(val, ind) in cols"
                        :key="ind">
                <!-- ES TEXTO ? -->
                <q-input outlined
                         class="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                         v-if="val.TYP == 'text' && !val.HID"
                         stack-label
                         :label="val.FLD"
                         v-model="editData[val.FLD]"
                         :rules="val.REQ ? [(val) => !!val || 'Campo requerido'] : []"
                         lazy-rules
                         dense
                         :hint="val.headerTooltip"
                         :disable="val.DIS"
                         autogrow></q-input>
                <!-- ES NUMERO ? -->
                <q-input outlined
                         class="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                         v-if="(val.TYP == 'number' || val.TYP == 'money') && !val.HID"
                         type="number"
                         stack-label
                         :label="val.FLD"
                         v-model="editData[val.FLD]"
                         :rules="val.REQ ? [(val) => !!val || 'Campo requerido'] : []"
                         lazy-rules
                         dense
                         :hint="val.headerTooltip"
                         :disable="val.DIS"
                         autogrow></q-input>
                <!-- ES SELECT? -->
                <q-select outlined
                          class="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                          v-if="val.TYP == 'select' && !val.HID"
                          stack-label
                          :label="val.FLD"
                          v-model="editData[val.FLD]"
                          :options="select[val.FLD]"
                          use-input
                          dense
                          options-dense
                          :multiple="val.MUL"
                          :hide-selected="!val.MUL"
                          input-debounce="0"
                          :disable="val.DIS"
                          @filter="
                            (va, update) => {
                              //esta funcion solo es para cuando se usa la busqueda al escribir que filtra segun se escriba
                              const source =
                                select2[val.FLD] != null && select2[val.FLD].length > 0
                                  ? select2[val.FLD]
                                  : val.LST || []; // Usar lista base (o array vacío si es null)
                              const filtered = source.map((i) => String(i ?? '')); // convertimos LST a string, por el problema al seleccionar el numero 0 que desaparece.
                              if (va === '') {
                                update(() => (select[val.FLD] = filtered));
                              } else {
                                const needle = va.toLowerCase();
                                update(() => {
                                  select[val.FLD] = filtered.filter((op) =>
                                    op.toLowerCase().includes(needle)
                                  );
                                }); // filtra la lista segun se escribe
                              }
                            }
                          "
                          @update:model-value="
                            (v) => {
                              select2 = [];
                              cdon.forEach((item) => {
                                Object.keys(item).forEach((key) => {
                                  if (editData[key] == item[key])
                                    Object.keys(item.OPT).forEach((lst) => {
                                      select2[lst] = item.OPT[lst];
                                    });
                                });
                              });
                            }
                          "
                          fill-input
                          :rules="val.REQ ? [(val) => !!val || 'Campo requerido'] : []"
                          lazy-rules
                          :hint="val.headerTooltip"
                          @new-value="newValue => editData[val.FLD] = newValue"></q-select>
                <!-- ES FECHA? -->
                <q-input outlined
                         v-if="
                          (val.TYP == 'datetime' || val.TYP == 'date') && !val.HID
                        "
                         :label="val.FLD"
                         class="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                         v-model="editData[val.FLD]"
                         :rules="val.REQ ? [(val) => !!val || 'Campo requerido'] : []"
                         :disable="val.DIS"
                         lazy-rules
                         dense
                         :hint="val.headerTooltip">
                  <template v-slot:append>
                    <q-icon name="event"
                            class="cursor-pointer">
                      <q-popup-proxy ref="qDateProxy"
                                     transition-show="scale"
                                     transition-hide="scale">
                        <q-date minimal
                                v-model="editData[val.FLD]"
                                mask="YYYY-MM-DD">
                          <div class="row items-center justify-end">
                            <q-btn v-close-popup
                                   label="Cerrar"
                                   color="primary"
                                   flat></q-btn>
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
                <!-- ES BIT? -->
                <q-checkbox v-if="val.TYP == 'bit' && !val.HID"
                            :label="val.FLD"
                            class="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                            v-model="editData[val.FLD]"
                            :false-value="0"
                            :true-value="1"
                            :rules="val.REQ ? [(val) => !!val || 'Campo requerido'] : []"
                            :disable="val.DIS"
                            lazy-rules
                            dense
                            :hint="val.headerTooltip"></q-checkbox>
              </template>
            </div>
          </q-form>
        </q-scroll-area>
      </q-tab-panel>
      <!-- PANEL PARA VER DATOS MODO LECTURA DE DATOS-->
      <q-tab-panel style="padding: 2px"
                   name="view">
        <!-- BOTONES DE GUARDAR Y VOLVER -->
        <q-bar class="bg-secondary text-primary">
          <q-space></q-space>
          <q-btn color="primary"
                 label="Volver"
                 @click="tab = 'grid'"></q-btn>
        </q-bar>
        <div class="col q-col-gutter-xs q-pa-xs">
          <template v-for="(val, ind) in cols"
                    :key="ind">
            <q-input outlined
                     v-if="!val.HID"
                     stack-label
                     :label="val.FLD"
                     :model-value="Array.isArray(editData[val.FLD])
                      ? editData[val.FLD].join(', ')
                      : editData[val.FLD]
                      "
                     dense
                     readonly></q-input>
          </template>
        </div>
      </q-tab-panel>
      <!-- PANEL PARA GRAFICOS CHARTS -->
      <q-tab-panel style="padding: 2px"
                   name="chart">
        <q-bar class="bg-secondary text-primary rounded-borders">
          <q-btn color="primary"
                 label="Series">
            <q-menu>
              <q-list dense
                      style="min-width: 100px"
                      v-for="(value, index) in chart.seriesMenu"
                      :key="index">
                <q-item>
                  <q-item-section>
                    <div class="q-gutter-xs">
                      <q-radio v-for="(e, i) in chart.yAxis"
                               :key="i"
                               dense
                               v-model="chart.series[value.i].yAxis"
                               :val="i"
                               :color="e.color"
                               vertical>
                      </q-radio>
                      <q-icon name="colorize"
                              class="cursor-pointer"
                              :style="{ color: chart.series[value.i].color }">
                        <q-popup-proxy>
                          <q-color v-close-popup
                                   v-model="chart.series[value.i].color"
                                   no-header
                                   no-footer
                                   default-view="palette"
                                   class="my-picker"></q-color>
                        </q-popup-proxy>
                      </q-icon>
                      {{ value.name }}
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
          <q-checkbox dense
                      v-model="showBand"
                      @click="onShowBand"
                      label="Banda"></q-checkbox>
          <q-space></q-space>
          <q-btn color="primary"
                 label="Volver"
                 @click="tab = 'grid'"></q-btn>
        </q-bar>
        <highcharts :options="chart"
                    style="height: 70vh" />
      </q-tab-panel>
      <!-- MAS PANELES PARA CONFIGURACIONES PERSONALIZADAS TABA, TABB, TABC -->
      <q-tab-panel style="padding: 2px"
                   name="tabA">
        <slot name="tabA"></slot>
      </q-tab-panel>
      <q-tab-panel style="padding: 2px"
                   name="tabB">
        <slot name="tabB"></slot>
      </q-tab-panel>
      <q-tab-panel style="padding: 2px"
                   name="tabC">
        <slot name="tabC"></slot>
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script setup>
/**
 * @component DataTable
 * @description Componente avanzado de tabla de datos basado en Ag-Grid con funcionalidades integradas
 *              de CRUD (Crear, Leer, Actualizar, Borrar), filtrado, ordenación, exportación a Excel,
 *              visualización de gráficos (Highcharts), paneles de edición/visualización, y soporte
 *              para relaciones maestro-detalle (hasta dos niveles). Utiliza Quasar para la interfaz.
 *
 * @props {Object} opts - (Requerido) Objeto de configuración principal para la tabla.
 *   @property {String} opts.table - Nombre de la tabla principal en la base de datos (usado para operaciones CRUD).
 *   @property {String} [opts.url] - URL específica para obtener los datos iniciales (si es diferente de la ruta estándar).
 *   @property {Object} [opts.post] - Datos adicionales a enviar en la petición POST al obtener/actualizar datos (ej. filtros fijos).
 *   @property {Array} [opts.cols] - (Opcional, normalmente se obtiene del servidor) Definición de columnas si se quiere personalizar desde el padre.
 *   @property {Object} [opts.defs] - Valores por defecto para campos específicos al crear un nuevo registro (ej. { 'Usuario': 'Admin' }).
 *   @property {Boolean} [opts.locked=false] - Si es `true`, deshabilita los botones de añadir, editar, duplicar y borrar.
 *   @property {Array<Object>} [opts.details] - Configuración para niveles de detalle maestro-detalle.
 *   @property {String} opts.details[].key - Nombre del campo en la fila maestra cuyo valor se usará para enlazar con la tabla de detalle.
 *   @property {String} opts.details[].table - Nombre de la tabla de detalle. El campo de enlace en esta tabla debe tener el mismo nombre que `key`.
 *
 * @emits onSelRow - Se emite cuando cambia la selección de fila.
 *   Payload: (Object | Boolean) - El objeto de datos de la fila seleccionada si solo hay una, o `false` si no hay selección o hay múltiples.
 * @emits onEdit - Se emite justo antes de mostrar el formulario de edición/inserción.
 *   Payload: (Object) - Un objeto con la propiedad `insert` que contiene los datos preparados para el formulario (ej. `{ insert: { campo1: 'valor1', ... } }`).
 * @emits onFilter - Se emite cuando los datos de la tabla se filtran (por filtro rápido, filtro de columna o filtro de fecha).
 *   Payload: (Array) - Un array con los objetos de datos que cumplen el filtro actual.
 * @emits onUpdate - Se emite después de que los datos de la tabla se han actualizado correctamente desde el servidor.
 *   Payload: (Object) - Un objeto con las propiedades `data` (el array de datos actualizado) y `cols` (la definición de columnas actualizada).
 *
 * @expose tab - (Ref<String>) Ref reactivo que controla el panel de pestañas activo ('grid', 'edit', 'view', 'chart', 'tabA', 'tabB', 'tabC'). Se puede modificar desde el padre.
 * @expose updateData - (Function) Función para recargar los datos de la tabla desde el servidor. Acepta `url` y `data` opcionales.
 * @expose setFilter - (Function) Función para aplicar un modelo de filtro de Ag-Grid a la tabla. Payload: (Object) - El modelo de filtro.
 * @expose clearCache - (Function) Función para limpiar la caché interna utilizada para las filas de detalle maestro-detalle. Útil si los datos del detalle cambian externamente.
 */
import { ModuleRegistry, ClientSideRowModelModule } from "ag-grid-community";
import { themeQuartz, iconSetQuartzLight } from "ag-grid-community";
import { AllEnterpriseModule } from "ag-grid-enterprise";
ModuleRegistry.registerModules([AllEnterpriseModule, ClientSideRowModelModule]);
import { AgGridVue } from "ag-grid-vue3";
import { ref, watch, inject, onMounted } from "vue";
import language from "../lang";
import { date, Dialog, Platform } from "quasar";
//** CONSTANTES GLOBALES */
const global = inject("global");
const tab = ref("grid");
const myTheme = themeQuartz.withPart(iconSetQuartzLight).withParams({
  accentColor: "#004B9C",
  backgroundColor: "#FDFDFD",
  borderRadius: 4,
  browserColorScheme: "light",
  columnBorder: false,
  foregroundColor: "#181D1F",
  headerBackgroundColor: "#EEB111",
  headerFontSize: 14,
  headerFontWeight: 600,
  headerTextColor: "#004B9C",
  listItemHeight: 20,
  iconSize: 14,
  spacing: 3,
  wrapperBorderRadius: 4,
});

/**
 * PROPS
 */

const props = defineProps({ opts: {} }); // propiedades de la tabla: table, table2, by, defs, post, url, cols(para personalizar columnas) // locked: true o false

/**
 * EMITS
 */

const emit = defineEmits([
  "onReady",
  "onSelRow",
  "onEdit",
  "onFilter",
  "onSave",
  "onUpdate",
]);

/**
 * EXPOSE
 */

defineExpose({ tab, updateData, setFilter, clearCache }); // es lo que se puede consultar en "ref" del componente y son funciones que se pueden llamar desde el componente padre

/**
 * CONSTANTES
 */

/**FORMULARIO EDICION */
const myForm = ref(null);
const fullData = ref({});
const editData = ref({});
const where = ref({});
const select = ref([]);
const select2 = ref([]);
const cols = ref();
const cdon = ref();
/**DATEPICKER */
const modelDate = ref(null);
const OkDate = ref(false);
const showDateSelector = ref(false);
/**HIGHCHART */
const defChart = {
  title: props.opts.table,
  chart: { type: "spline", zoomType: "xy" },
  lang: language.es.chart,
  credits: { enabled: false },
  series: [],
  xAxis: {},
  tooltip: { dateTimeLabelFormats: { day: "%d.%m.%y %Hh" } },
  plotOptions: {
    spline: { marker: { enabled: true } },
    column: { stacking: "percent" },
    connectNulls: true,
    series: {
      events: {
        legendItemClick: function (event) {
          seriesActive(
            { name: this.name, col: this.color, i: this.index },
            this.index
          );
          chart.value.series[this.index].visible =
            !chart.value.series[this.index].visible;
        },
      },
    },
  },
  yAxis: [
    // Definición del primer eje Y (principal)
    {
      opposite: false,
      events: { afterSetExtremes: function (e) { getAxis(e, 0); }, },
      type: "linear",
      plotBands: [],
      title: { offset: 0, align: "high", text: false, rotation: 0, y: -10 },
      labels: { style: { color: "#000000" } },
      color: "black",
    },
    // Ejes Y adicionales generados dinámicamente
    ...["#0023FF", "#66A94F", "#9e9e9e", "#A52A2A", "#FF0000", "#800080", "#008080"].map((color, index) => ({
      opposite: true,
      events: { afterSetExtremes: function (e) { getAxis(e, index + 1); }, },
      type: "linear",
      plotBands: [],
      title: { offset: 0, align: "high", text: false, rotation: 0, y: -10 },
      labels: { style: { color: color } },
      color: color,
    })),
  ],
  seriesMenu: [],
  accessibility: { enabled: false },
};
const chart = ref();
const chartSeries = ref([]);
const axis = ref([
  { min: 0, max: 0 },
  { min: 0, max: 0 },
  { min: 0, max: 0 },
  { min: 0, max: 0 },
  { min: 0, max: 0 },
  { min: 0, max: 0 },
  { min: 0, max: 0 },
  { min: 0, max: 0 },
]);
const showBand = ref(false);
/**DATATABLE */
const rowData = ref();
const columnDefs = ref();
const rowClassRules = ref({});
const lang = language.es.table;
const query = ref();
const gridApi = ref();
const columnApi = ref();
const selRow = ref();
const selRowData = ref();
const quickFilter = ref("");
const createFilterParams = (filterType) => ({
  filters: [{ filter: filterType }, { filter: "agSetColumnFilter" }],
});
const columnTypes = {
  date: {
    filter: "agSetColumnFilter",
    filterParams: { treeList: true },
    cellRenderer: (p) => (p.value === "0000-00-00" || p.value === null ? "" : new Date(p.value).toLocaleDateString("es-ES")),
  },
  datetime: { filter: "agSetColumnFilter", filterParams: { treeList: true } },
  number: {
    enableValue: true,
    filterParams: createFilterParams("agNumberColumnFilter"),
  },
  money: {
    valueFormatter: (p) =>
      p.value !== undefined && p.value !== null
        ? p.value.toLocaleString("es", { useGrouping: true, minimumFractionDigits: 2 }) + " €"
        : "",
    enableValue: true,
    filterParams: createFilterParams("agNumberColumnFilter"),
  },
  text: {
    valueFormatter: (p) => (p.value !== null && p.value !== undefined ? p.value.toString() : ""),
    filterParams: createFilterParams("agTextColumnFilter"),
  },
  bit: {
    cellRenderer: (params) => `<input type='checkbox' onclick="return false;" ${params.value === 0 ? "" : "checked"} />`,
  },
  select: {},
};
const defaultColDef = {
  enablePivot: true,
  editable: false,
  resizable: true,
  filter: "agMultiColumnFilter",
  sortable: true,
  enableRowGroup: true,
  floatingFilter: false,
  menuTabs: ["filterMenuTab", "generalMenuTab"],
};
const statusBar = {
  statusPanels: [
    { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
    { statusPanel: "agFilteredRowCountComponent" },
    { statusPanel: "agSelectedRowCountComponent" },
    { statusPanel: "agAggregationComponent" },
  ],
};
const sideBar = {
  toolPanels: [
    {
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
    },
    {
      id: "filters",
      labelDefault: "Filters",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel",
    },
  ],
  defaultToolPanel: "",
};
const rowSelection = {
  mode: "multiRow",
  rowMultiSelectWithClick: false,
  suppressRowClickSelection: false
};
const autoSizeStrategy = {
  type: "fitCellContents",
};
const selectionColumnDef = {
  pinned: "left",
  headerTooltip: "Checkboxes indicate selection",
};
const detailCellRendererParams = ref(null); // Se construirá dinámicamente
const detailCaches = ref([]); // Array de objetos caché, uno por nivel de detalle

/**
 * FUNCIONES
 */

/**
 * @function getContextMenuItemsMaster
 * @description Define los elementos del menú contextual para la tabla maestra.
 *              Filtra las opciones de exportación por defecto de Ag-Grid.
 * @param {Object} params - Parámetros proporcionados por Ag-Grid para el menú contextual.
 * @returns {Array<Object|String>} Un array de elementos del menú contextual.
 */
function getContextMenuItemsMaster(params) {
  const defaultItems = params.defaultItems ? params.defaultItems.slice() : [];
  // Filtrar opciones de exportación
  const filteredDefaultItems = defaultItems.filter(item => {
    if (typeof item === 'string') {
      return !item.includes('export'); // Eliminar elementos que contengan 'export' en su nombre
    }
    return true;
  });
  return filteredDefaultItems;
}

/**
 * @function setupDetailLevels
 * @description Configura dinámicamente los niveles de detalle maestro-detalle para Ag-Grid.
 *              Pre-carga las definiciones de columnas para cada nivel de detalle y construye
 *              la estructura anidada de `detailCellRendererParams`. Incluye lógica para
 *              manejar la caché de datos de detalle y un menú contextual para eliminar filas de detalle.
 */
async function setupDetailLevels() {
  const detailsConfig = props.opts.details;
  if (detailsConfig && detailsConfig.length > 0) {
    // Pre-cargar definiciones de columnas para todos los niveles de detalle
    const colDefsPromises = detailsConfig.map(async (detailConf, level) => {
      const colRes = await global.db("/app/db/sel1Detail" + detailConf.table, { table: detailConf.table, query: "cols" }, false); // Solo esquema
      let detailColDefs = [];
      if (colRes.success && colRes.cols) {
        detailColDefs = colRes.cols.map(({ FLD, HDN, TYP }) => ({
          ...defaultColDef, // Asegúrate que defaultColDef esté disponible
          field: FLD,
          hide: HDN || FLD === detailConf.key, // Ocultar la columna de enlace en la tabla de detalle (asume mismo nombre que key)
          type: TYP,
        }));

        // Si hay un siguiente nivel de detalle, marcar la primera columna visible para expansión
        if (level + 1 < detailsConfig.length) {
          const firstVisible = detailColDefs.find(c => !c.hide);
          if (firstVisible) firstVisible.cellRenderer = "agGroupCellRenderer";
        }
      }
      return { level, colDefs: detailColDefs };
    });

    const allDetailColDefsSetup = await Promise.all(colDefsPromises);

    /**
     * @function buildNestedDetailParams
     * @description Función recursiva interna para construir la estructura anidada de `detailCellRendererParams`.
     * @param {number} level - El nivel actual de detalle que se está construyendo.
     * @returns {Object|undefined} Los parámetros del renderer de celda de detalle para el nivel actual, o `undefined` si no hay más niveles.
     */
    function buildNestedDetailParams(level) {
      if (level >= detailsConfig.length) return undefined; // Condición de parada para la recursión

      const currentDetailConfig = detailsConfig[level];
      const { key, table } = currentDetailConfig; // Usar 'key' y 'table'

      // Asegurar que el caché para este nivel exista
      if (!detailCaches.value[level]) {
        detailCaches.value[level] = {};
      }
      const currentLevelCache = detailCaches.value[level];

      const colDefsSetup = allDetailColDefsSetup.find(s => s.level === level);
      const currentLevelColDefs = colDefsSetup ? colDefsSetup.colDefs : [];

      return {
        getDetailRowData: async (params) => {
          const masterValue = params.data[key]; // Usar 'key'
          if (currentLevelCache[masterValue]) {
            return params.successCallback(currentLevelCache[masterValue]);
          }
          const res = await global.db("/app/db/sel2Detail" + table, { table: table, query: "select", where: { [key]: masterValue } }, false); // Usar 'key' para la FK y 'table'
          if (res.success) {
            currentLevelCache[masterValue] = res.data;
            params.successCallback(res.data);
          } else {
            console.error(`Error cargando datos para el detalle ${table}:`, res.message);
            params.successCallback([]); // Devolver array vacío en caso de error
          }
        },
        detailGridOptions: {
          columnDefs: currentLevelColDefs,
          columnTypes: columnTypes, // Asumido global
          localeText: lang,       // Asumido global
          masterDetail: (level + 1 < detailsConfig.length), // Hay más niveles?
          detailRowHeight: 200, // O hacerlo configurable
          autoSizeStrategy: { type: "fitCellContents" },
          detailCellRendererParams: buildNestedDetailParams(level + 1), // Llamada recursiva
          getContextMenuItems: (params) => { // Menú contextual para filas de detalle
            const defaultItems = params.defaultItems ? params.defaultItems.slice() : [];
            // Filtrar opciones de exportación
            const filteredDefaultItems = defaultItems.filter(item => {
              if (typeof item === 'string') {
                return !item.includes('export'); // Eliminar elementos que contengan 'export' en su nombre
              }
              return true;
            });
            const result = [
              ...filteredDefaultItems,
              "separator",
              {
                name: `Eliminar Fila de ${table}`,
                icon: '<span class="q-icon material-icons text-negative">delete</span>',
                action: async () => {
                  const rowDataToDelete = params.node.data;
                  const parentMasterRowData = params.node.parentRowNode?.data;
                  const parentMasterKeyValueForCache = parentMasterRowData ? parentMasterRowData[key] : null; // Usar 'key'

                  Dialog.create({
                    title: "Confirmar Eliminación",
                    message: `¿Estás seguro de que quieres eliminar este registro de ${table} (ID: ${rowDataToDelete.id})? Esta acción no se puede deshacer.`,
                    cancel: true,
                    persistent: true,
                    ok: { color: "negative", label: "Eliminar" },
                  }).onOk(async () => {
                    const deleteResponse = await global.db("/app/db/delDetail" + table, { table: table, query: "delete", where: { id: rowDataToDelete.id } });
                    if (deleteResponse.success) {
                      params.api.applyTransaction({ remove: [rowDataToDelete] });
                      // Invalidar caché para el padre usando 'key'
                      if (parentMasterKeyValueForCache && currentLevelCache[parentMasterKeyValueForCache]) {
                        const idx = currentLevelCache[parentMasterKeyValueForCache].findIndex(item => item.id === rowDataToDelete.id);
                        if (idx > -1) currentLevelCache[parentMasterKeyValueForCache].splice(idx, 1);
                        if (currentLevelCache[parentMasterKeyValueForCache].length === 0) delete currentLevelCache[parentMasterKeyValueForCache];
                      }
                      clearCache();
                    }
                  });
                },
                disabled: !params.node || !params.node.data || !params.node.data.id,
              },
            ];
            return result;
          },
        },
      };
    }
    detailCellRendererParams.value = buildNestedDetailParams(0);
  } else {
    detailCellRendererParams.value = null; // Sin detalles
  }
}

/**
 * @function checkDate
 * @description Maneja la selección de fechas desde el datepicker.
 *              Si se confirma la selección, actualiza los datos de la tabla con el rango de fechas.
 *              Si se cancela, limpia el rango de fechas.
 * @param {boolean} state - `true` si se confirma la selección, `false` si se cancela.
 */
async function checkDate(state) {
  if (state === true && OkDate.value === true && modelDate.value) {
    const res = await global.db("/app/db/selDates", { ...props.opts.post, between: { Fecha: modelDate.value } })
    updateData(res)
  } else if (state === false) {
    modelDate.value = null;
    OkDate.value = false;
  }
}

/**
 * @function viewChart
 * @description Prepara y muestra los datos de la tabla en un gráfico Highcharts.
 *              Filtra las columnas numéricas y de dinero para crear series de datos.
 */
function viewChart() {
  const sortedData = chartSeries.value.sort((a, b) => a["Fecha"] - b["Fecha"]);
  const series = columnDefs.value
    .filter(
      (columnDef) =>
        !columnDef.field.startsWith("id") &&
        ["number", "money"].includes(columnDef.type)
    )
    .map((columnDef) => ({
      name: columnDef.field,
      data: sortedData
        .map((row) => ({
          x: new Date(row["Fecha"]).getTime(),
          y: row[columnDef.field],
        }))
        .sort((a, b) => (a.x === b.x ? a.y - b.y : a.x - b.x)),
      visible: false, // Agrega esta propiedad para desactivar la serie inicialmente
    }));
  chart.value = {
    ...defChart,
    series,
    xAxis: [
      {
        title: { text: "Fecha" },
        type: "datetime",
        dateTimeLabelFormats: {
          day: "%d/%m/%Y",
          week: "%d/%m",
          month: "%m/%Y",
          year: "%Y",
        },
      },
    ],
  };
  tab.value = "chart";
}

/**
 * @function getAxis
 * @description Actualiza los valores mínimos y máximos de un eje del gráfico.
 * @param {Object} value - Objeto de evento que contiene `dataMin` y `dataMax`.
 * @param {number} ax - Índice del eje a actualizar.
 */
function getAxis(value, ax) {
  axis.value[ax].min = value.dataMin;
  axis.value[ax].max = value.dataMax;
}

/**
 * @function seriesActive
 * @description Gestiona la visibilidad y el color de las series en el menú del gráfico.
 * @param {Object} value - Objeto con `name`, `col` (color) e `i` (índice) de la serie.
 * @param {number} id - Índice de la serie en el array `chart.value.series`.
 */
function seriesActive(value, id) {
  let exist = false;
  for (var i = 0; i < chart.value.seriesMenu.length; i++) {
    if (chart.value.seriesMenu[i].name === value.name) {
      chart.value.seriesMenu.splice(i, 1);
      exist = true;
      break;
    }
  }
  if (!exist) {
    chart.value.seriesMenu.push(value);
    chart.value.series[id].color = value.col;
  }
}

/**
 * @function onShowBand
 * @description Alterna la visibilidad de las bandas de trazado en el eje Y principal del gráfico.
 */
function onShowBand() {
  chart.value.yAxis[0].plotBands = showBand.value ? chart.value.plotBands : [];
}

/**
 * @function onFilterChanged
 * @description Se ejecuta cuando el filtro de la tabla Ag-Grid cambia.
 *              Emite los datos filtrados y actualiza la serie de datos para los gráficos.
 * @param {Object} event - Objeto de evento de Ag-Grid.
 */
function onFilterChanged(event) {
  let rowData = [];
  event.api.forEachNodeAfterFilter((node) => {
    rowData.push(node.data);
  });
  emit("onFilter", rowData);
  chartSeries.value = rowData;
}

/**
 * @function onRowValueChanged
 * @description Se ejecuta cuando el valor de una fila cambia. (Actualmente no se usa para edición en línea).
 * @param {Object} event - Objeto de evento de Ag-Grid.
 */
function onRowValueChanged(event) {
  // Esta función se mantiene para compatibilidad, pero la edición se realiza a través del formulario.
}

/**
 * @function onModelUpdated
 * @description Se ejecuta cuando el modelo de datos de Ag-Grid se ha actualizado completamente.
 *              Asegura que la selección de filas se actualice correctamente.
 * @param {Object} event - Objeto de evento de Ag-Grid.
 */
function onModelUpdated(event) {
  onSelectionChanged(event);
}

/**
 * @function onSelectionChanged
 * @description Se ejecuta cuando la selección de filas en la tabla Ag-Grid cambia.
 *              Actualiza `selRow` y `selRowData` y emite el evento `onSelRow`.
 * @param {Object} event - Objeto de evento de Ag-Grid.
 */
function onSelectionChanged(event) {
  selRow.value = event.api.getSelectedNodes().length == 1 ? true : false;
  selRowData.value =
    event.api.getSelectedNodes().length == 1
      ? event.api.getSelectedNodes()[0].data
      : {};
  selRow.value ? emit("onSelRow", selRowData.value) : emit("onSelRow", false);
  selRow.value ? (fullData.value = selRowData.value) : "";
}

/**
 * @function onGridReady
 * @description Se ejecuta cuando el grid de Ag-Grid está listo.
 *              Asigna las APIs del grid y de las columnas.
 * @param {Object} params - Parámetros proporcionados por Ag-Grid.
 */
function onGridReady(params) {
  gridApi.value = params.api;
  columnApi.value = params.columnApi;
}

/**
 * @function onGridSizeChanged
 * @description Se ejecuta cuando el tamaño del grid de Ag-Grid cambia.
 *              Ajusta el tamaño de las columnas para que se ajusten al contenedor.
 * @param {Object} params - Parámetros proporcionados por Ag-Grid.
 */
function onGridSizeChanged(params) {
  if (params.api) {
    params.api.sizeColumnsToFit();
  }
}

/**
 * @function onFirstDataRendered
 * @description Se ejecuta después de que los datos iniciales se han renderizado en el grid.
 *              Ajusta el tamaño de las columnas para que se ajusten al contenedor.
 * @param {Object} params - Parámetros proporcionados por Ag-Grid.
 */
function onFirstDataRendered(params) {
  if (params.api) {
    params.api.sizeColumnsToFit();
  }
}

/**
 * @function setFilter
 * @description Aplica un modelo de filtro a la tabla Ag-Grid.
 * @param {Object} d - El modelo de filtro a aplicar.
 */
function setFilter(d) {
  gridApi.value.setFilterModel(d);
}

/**
 * @function exportExcel
 * @description Exporta los datos de la tabla a un archivo Excel, con una advertencia de confidencialidad
 *              y un límite de 50 registros. Envía una notificación por correo electrónico.
 */
function exportExcel() {
  Dialog.create({
    title: "Advertencia de Confidencialidad y Uso Legal",
    message: `
      ATENCIÓN: Accedes/descargas información confidencial de TOTSEGUR SCP.\n
      Su uso es exclusivo para tus funciones laborales. Cualquier uso o divulgación externa no autorizada está estrictamente prohibida y puede ser objeto de acciones legales según la legislación española.\n
      Descarga limitada a 50 registros. Si está de acuerdo pulse aceptar para continuar. Todas las actividades son monitoreadas y registradas.
    `,
    html: true,
    cancel: true,
    persistent: true,
    ok: {
      label: "Aceptar",
      color: "primary"
    },
    cancel: {
      label: "Cancelar",
      color: "negative"
    }
  }).onOk(() => {
    let mensaje = `
      <div class="container">
        <div class="header">
          <h2>Notificación de Descarga de Información</h2>
        </div>
        <div class="content">
          <p>Estimado/a usuario/a,</p>
          <p>Le informamos que se ha realizado una descarga de información desde la aplicación <span class="highlight">DARE</span>.</p>
          <p><strong>Detalles de la operación:</strong></p>
          <ul>
            <li><strong>Fecha y Hora:</strong> ${new Date()}</li>
            <li><strong>Tipo de Información:</strong> ${props.opts.post.table}</li>
          </ul>
          <p>Este correo es una notificación automática para su conocimiento y registro de actividad.</p>
          <p>Si usted no reconoce esta actividad o tiene alguna pregunta, por favor, póngase en contacto con su responsable.</p>
        </div>
        <div class="footer">
          <p>&copy; ${new Date().getFullYear()} TOTSEGUR S.C.P. Todos los derechos reservados.</p>
          <p>Este es un mensaje generado automáticamente, por favor no responda a este correo.</p>
        </div>
      </div>
    `
    global.db("/app/log", { action: "Descarga", message: "Excel: Descargado datos de la tabla " + props.opts.post.table });
    global.db("/app/sendMail", { data: { Para: global.user.mail, Asunto: "Información de descargas de Dare", Mensaje: mensaje } })
    let rowCount = 0; // Initialize a counter for the rows
    let excelParams = {
      fileName: "ExpotarDare.xlsx", sheetName: "Dare",
      shouldRowBeSkipped: (params) => {
        if (rowCount < 50) {
          rowCount++; // Increment the counter
          return false; // Don't skip the row (include it)
        } else {
          return true; // Skip the row (exclude it)
        }
      },
    };
    gridApi.value.exportDataAsExcel(excelParams);
  }).onCancel(() => {
    // No hacer nada si se cancela
  });
}

/**
 * @function clearCache
 * @description Limpia la caché interna utilizada para las filas de detalle maestro-detalle.
 *              Útil si los datos del detalle cambian externamente y se necesita forzar una recarga.
 */
function clearCache() {
  if (gridApi.value && !gridApi.value.isDestroyed()) {
    detailCaches.value.forEach(cacheLevel => {
      Object.keys(cacheLevel).forEach(key => delete cacheLevel[key]);
    });
    gridApi.value.refreshCells({ force: true }); // Actualizar la cuadrícula si es necesario
  }
}

/**
 * @function prepareData
 * @description Prepara los datos para las operaciones de inserción, duplicación, actualización,
 *              visualización o eliminación, y cambia la pestaña a la vista correspondiente.
 * @param {string} action - La acción a realizar ('insert', 'duplicate', 'update', 'view', 'delete').
 */
function prepareData(action) {
  editData.value = {}
  where.value = {}
  editData.value = global.data.clone(fullData.value);
  if (cols.value !== undefined) {
    switch (action) {
      case "insert":
        prepareDefaults();
        prepareRemoveId();
        tab.value = "edit";
        query.value = "insert"
        break;
      case "duplicate":
        prepareDate("Fecha");
        prepareZeros();
        prepareRemoveId();
        tab.value = "edit";
        query.value = "insert"
        break;
      case "update":
        prepareRemoveId();
        prepareUpdate();
        tab.value = "edit";
        query.value = "update"
        break;
      case "view":
        tab.value = "view";
        break;
      case "delete":
        prepareDelete();
        query.value = "delete"
        tab.value = "grid";
        break;
      default:
        break;
    }
  }
  emit("onEdit", { insert: editData.value });
}

/**
 * @function prepareDefaults
 * @description Establece los valores por defecto para los campos de `editData`
 *              basándose en el tipo de columna y las definiciones de `props.opts.defs`.
 *              Asigna la fecha/hora actual para campos de fecha/hora y el usuario actual para el campo "Usuario".
 */
function prepareDefaults() {
  const now = Date.now();
  cols.value.forEach((el) => {
    let defaultValue = el.DEF;

    switch (el.TYP) {
      case "datetime":
        defaultValue = date.formatDate(now, "YYYY-MM-DD HH:mm");
        break;
      case "date":
        defaultValue = date.formatDate(now, "YYYY-MM-DD");
        break;
      case "text":
      case "select":
        defaultValue = el.DEF ?? null;
        break;
      case "number":
        defaultValue = el.DEF ? String(el.DEF) : "0";
        break;
      case "bit":
      case "money":
        defaultValue = el.DEF ? el.DEF : 0;
        break;
    }

    if (el.TYP === "select" && el.MUL) {
      editData.value[el.FLD] = [];
    } else {
      editData.value[el.FLD] = defaultValue;
    }

    // Sobrescribir con valores de props.opts.defs si existen
    if (props.opts.hasOwnProperty("defs") && props.opts.defs.hasOwnProperty(el.FLD)) {
      editData.value[el.FLD] = props.opts.defs[el.FLD];
    }
    // Asignar usuario si el campo es "Usuario" y no está en defs o no tiene un valor definido
    if (el.FLD === "Usuario" && (!props.opts.defs || !props.opts.defs[el.FLD])) {
      editData.value[el.FLD] = global.user.name;
    }
  });
}

/**
 * @function prepareRemoveId
 * @description Elimina la propiedad 'id' de `editData` si existe, ya que se genera automáticamente en la base de datos.
 */
function prepareRemoveId() {
  if (editData.value.hasOwnProperty("id")) delete editData.value["id"];
}

/**
 * @function prepareDate
 * @description Actualiza el campo de fecha especificado en `editData` con la fecha y hora actuales.
 * @param {string} dd - El nombre del campo de fecha a actualizar.
 */
function prepareDate(dd) {
  if (editData.value.hasOwnProperty(dd))
    editData.value[dd] = date.formatDate(Date.now(), "YYYY-MM-DD HH:mm");
}

/**
 * @function prepareZeros
 * @description Convierte los valores numéricos de 0 a la cadena "0" en `editData` para ciertos tipos de campo.
 */
function prepareZeros() {
  cols.value.forEach((el) => {
    if (editData.value[el.FLD] === 0) editData.value[el.FLD] = "0";
  });
}

/**
 * @function prepareUpdate
 * @description Prepara los datos para una operación de actualización.
 *              Establece la condición `where` con el ID original y formatea los campos de selección múltiple.
 */
function prepareUpdate() {
  where.value = { id: fullData.value.id };
  cols.value.forEach((el) => {
    const fieldValue = editData.value[el.FLD];

    if (el.TYP === "select" && el.MUL && fieldValue !== null && fieldValue !== undefined) {
      // editData.value[el.FLD] = Array.isArray(fieldValue)
      //   ? fieldValue.join(",").trim().replace(/^,+|,+$/g, "")
      //   : fieldValue;
      // Para casos de Multiples selecciones
      el.LST = el.LST.map((num) => num.toString());
      editData.value[el.FLD] = editData.value[el.FLD].toString().split(",");
    } else if ((el.TYP === "select" || el.TYP === "number") && fieldValue === 0) {
      editData.value[el.FLD] = "0";
    }
  });
}

/**
 * @function prepareDelete
 * @description Muestra un diálogo de confirmación antes de eliminar un registro.
 *              Si se confirma, realiza la operación de eliminación y actualiza los datos de la tabla.
 */
function prepareDelete() {
  Dialog.create({
    title: "Confirma",
    message: "¿Eliminar el registro?",
    cancel: true,
    persistent: true,
    ok: { color: "negative" },
  }).onOk(async () => {
    try {
      let data = [
        { table: props.opts.post.table, query: "delete", where: { id: fullData.value.id } },
        { ...props.opts.post }
      ]
      const res = await global.db("/app/db/delTable", data)
      updateData(res)
      emit("onUpdate", { query: query.value });
    } catch (error) {
    }
  });
}

/**
 * @function onSave
 * @description Valida el formulario, formatea los datos según el tipo de columna
 *              y guarda el registro en la base de datos (insertar o actualizar).
 *              Luego, actualiza la tabla y emite el evento `onUpdate`.
 */
async function onSave() {
  if (myForm.value !== null) {
    const success = await myForm.value.validate();
    if (success) {
      if (cols.value !== undefined) {
        cols.value.forEach((el) => {
          if (
            editData.value[el.FLD] !== undefined &&
            editData.value[el.FLD] !== null
          ) {
            if (el.TYP == "number" || el.TYP == "bit" || el.TYP == "money")
              editData.value[el.FLD] = parseFloat(
                editData.value[el.FLD].toString().replace(",", ".")
              );
            else if (el.TYP == "select" && el.MUL)
              editData.value[el.FLD] = Array.isArray(editData.value[el.FLD])
                ? editData.value[el.FLD]
                  .join(",")
                  .trim()
                  .replace(/^,+|,+$/g, "")
                : editData.value[el.FLD];
          }
        });
      }
      tab.value = "grid";
      let dataSave = [
        { table: props.opts.post.table, query: query.value, data: editData.value, where: where.value },
        { ...props.opts.post }
      ];

      const res = await global.db("/app/db/saveTable", dataSave);
      emit("onUpdate", { query: query.value });
      updateData(res)
    } else {
      return;
    }
  }
}

/**
 * @function update
 * @description Función para iniciar la recarga de datos de la tabla desde el servidor.
 *              Delega el procesamiento de la respuesta a `updateData`.
 * @param {Object} [data={}] - Datos adicionales a enviar en la petición.
 * @throws {Error} Si ocurre un error durante la llamada a la base de datos.
 */
async function update(data = {}) {
  try {
    const res = await global.db("/app/db/updTable", data);
    updateData(res)
  } catch (error) {
    console.error("Error en la función:", error);
    throw error;
  }
}

/**
 * @function updateData
 * @description Procesa la respuesta de la base de datos para actualizar las columnas,
 *              los datos de las filas, las reglas de clase de fila y la configuración del selector de fechas.
 *              También configura la primera columna para expansión si hay detalles definidos.
 * @param {Object|Array<Object>} res - La respuesta de la base de datos, que puede ser un objeto o un array de objetos.
 * @throws {Error} Si ocurre un error durante el procesamiento de los datos.
 */
function updateData(res) {
  const processSingleUpdate = (r) => {
    try {
      if (typeof r.data !== 'undefined' && typeof r.cols !== 'undefined' && r.data !== null && r.cols !== null) {
        cols.value = r.cols;
        cdon.value = r.cdon ?? [];
        columnDefs.value = cols.value.map((col) => {
          const columnDef = {
            field: col.FLD,
            hide: col.HDN,
            type: col.TYP,
            pinned: col.PIN,
            cellClassRules: col.RUL,
            rowGroup: col.GRP,
          };

          // Aplicar agrupamiento si opts.group está definido y la columna está en la lista
          if (props.opts.group && props.opts.group.includes(col.FLD)) {
            columnDef.rowGroup = true;
            columnDef.hide = true;
          }

          // Aplicar visibilidad de columna desde opts.cols si está definida
          if (props.opts.cols && props.opts.cols.hasOwnProperty(col.FLD)) {
            if (props.opts.cols[col.FLD] === 'Hh') {
              columnDef.hide = true;
            } else if (props.opts.cols[col.FLD] === '') {
              columnDef.hide = false;
            }
          }
          return columnDef;
        });
        rowData.value = r.data;
        rowClassRules.value = r.rules ?? [];
        // Configurar la primera columna para expansión si hay detalles definidos
        if (props.opts.details && props.opts.details.length > 0) {
          const firstVisibleColumn = columnDefs.value.find((col) => !col.hide);
          if (firstVisibleColumn)
            firstVisibleColumn.cellRenderer = "agGroupCellRenderer";
        }
        showDateSelector.value = cols.value.some((col) => col.FLD === "Fecha" && !col.HDN);
        chartSeries.value = r.data;
        clearCache();
        emit("onUpdate", { data: r.data, cols: r.cols, query: "select" });
      }
    } catch (error) {
      console.error("Error al actualizar datos:", error);
      throw error;
    }
  };

  if (Array.isArray(res)) {
    res.forEach((r) => {
      processSingleUpdate(r);
    });
  } else {
    processSingleUpdate(res);
  }
}

/**
 * @function onMounted
 * @description Hook del ciclo de vida de Vue que se ejecuta después de que el componente ha sido montado.
 *              Actualmente, la configuración inicial de los detalles se maneja a través de un observador con `immediate: true`.
 */
onMounted(() => {
  // La configuración inicial de detalles se maneja con el watch immediate:true
});
/**
 * @description Observadores (watchers) para propiedades reactivas.
 * @watch quickFilter.value - Actualiza el filtro rápido de Ag-Grid cuando cambia.
 * @watch props.opts.details - Reconfigura los niveles de detalle cuando la configuración de detalles cambia.
 */
watch(
  () => quickFilter.value,
  () => { gridApi.value.setGridOption("quickFilterText", quickFilter.value) },
);
watch(() => props.opts.details, () => { setupDetailLevels(); }, { deep: true, immediate: true })
</script>

<style>
.RO {
  background-color: #f5a9a9;
}

.VE {
  background-color: #b6ffbf;
}

.AZ {
  background-color: #88c9ff;
}

.AM {
  background-color: #fcf18e;
}

.GR {
  background-color: #a8a8a7;
}

.NG {
  background-color: #000000;
  color: #ffffff;
}
</style>
